import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, processingAgencyRegistrationTypesId) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/RegistrationTypes/${processingAgencyRegistrationTypesId}`, method: 'DELETE', body: null, token: token })
}
